import {client, getUrl} from "utils";

export const getCountriesRequest = () =>  client.get("countries");

export const getRolesRequest = () =>  client.get("roles");

export const getTenantsRequest = () =>  client.get("tenants");

export const getReceiverRequest = () =>  client.get("receiver");

export const getBrandRequest = () =>  client.get("brands");

export const getBranchRequest = () =>  client.get("branches");

export const getSiteGroupsRequest = () =>  client.get("site-groups");

export const getSourceRequest = () =>  client.get("source");

export const getStatusTypeRequest = () =>  client.get("status-type");

export const getStatusRequest = () =>  client.get("status");

export const getValidatorsObjectPropertiesRequest = () =>  client.get("validators-for-object-properties");

export const getUserAgentsRequest = () =>  client.get("user-agents?limit=100000&sort_direction=asc");

export const getResponseProviderRequest = () =>  client.get("response-provider");

export const getProxyTypeRequest = () =>  client.get("proxy-type");

export const getRetryRuleTypeRequest = () =>  client.get("retry-rule-type");

export const getRetryRuleActionRequest = () =>  client.get("retry-rule-action");

export const getTemplateSelectorSourceRequest = () =>  client.get("template-selector-source");

export const getTemplateSelectorConditionRequest = () =>  client.get("template-selector-condition");

export const getTemplateSelectorTypeRequest = () =>  client.get("template-selector-type");

export const getTemplateScreenshotActionRequest = () =>  client.get("template-screenshot-actions");

export const getBlockSelectorSourceRequest = () =>  client.get("block-selector-source");

export const getBlockSelectorTypeRequest = () =>  client.get("block-selector-type");

export const getDataSelectorTypeRequest = () =>  client.get("data-selector-type");

export const getDataSelectorActionRequest = () =>  client.get("data-selector-action");

export const getNormalizerRequest = () =>  client.get("normalizer");

export const getConditionTypeRequest = () =>  client.get("data-selector-condition-type");

export const getObjectStructuresRequest = ({ receiverCode }) =>  client.get(`object-structures?receiver_code=${receiverCode}`);

export const getPublishRequestStatusesRequest = () =>  client.get("publish-request-statuses");

export const getUsersRequest = (filterParams) => client.get(getUrl("users", filterParams));

export const getConfigCiTestTaskProgressesRequest = () =>  client.get("config-ci-test-task-progresses");

export const getHttpMethodFieldRequest = () =>  client.get("http-method");

export const getMetricTaskExecutorsRequest = () =>  client.get("metric-task-executors");

export const getMetricTaskTemplatesRequest = () =>  client.get("metric-task-templates");

export const getCredentialsTypesRequest = () =>  client.get("credentials-types");

export const getBrightDataScrapingBrowserCredentialsRequest = () =>  client.get("credentials?enabled=1&limit=200&offset=0&type_code=BRIGHTDATA_SCRAPING_BROWSER");

export const getOxylabsScrapingBrowserCredentialsRequest = () =>  client.get("credentials?enabled=1&limit=200&offset=0&type_code=OXYLABS_SCRAPING_BROWSER");

export const getStorageTypesRequest = () =>  client.get("storage-types");

export const getProxyTagsRequest = () =>  client.get("tags");

export const getPlatformsRequest = () =>  client.get("platforms");

export const branchTagsRequest = () =>  client.get("branch-tags");

export const searchUrlPatternTypesRequest = () =>  client.get("search-url-pattern-types");

export const searchUrlPatternSortingsRequest = () =>  client.get("search-url-pattern-sortings");

export const primaryKeyItemTypesRequest = () =>  client.get("primary-key/item-types");

export const quotaTypesRequest = () =>  client.get("quota-types");
